module.exports = __webpack_public_path__ + "fa-regular-400.0bb428459c8ecfa61b22.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-regular-400.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-regular-400.svg
// module chunks = styles